export default __webpack_public_path__ + "static/treatmentareas_brazilian-78594c676c4cf422c4377ad20b06c97d.webp";